import axios from 'axios';
import * as Sentry from '@sentry/react';
import { variablesGlobales } from '../configs/variables';

// Códigos/estados que SÍ se reportan a GlitchTip: fallas de infraestructura,
// no respuestas de validación normales del backend (401/404/409, etc.)
const REPORTABLE_ERROR_CODES = new Set(['ERR_NETWORK', 'ECONNABORTED']);

const getInstanceAxios = () => {
  const axiosInstance = axios.create({
    baseURL: variablesGlobales.urlServiceBackend,
    withCredentials: true // Incluye las credenciales (cookies) en la solicitud
  });

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      try {
        const status = error?.response?.status;
        const isReportable = REPORTABLE_ERROR_CODES.has(error?.code) || status >= 500;
        if (isReportable) {
          Sentry.captureException(error);
        }
      } catch (sentryError) {
        // Nunca debe romper la petición original por un fallo de Sentry/GlitchTip
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance
}



export default getInstanceAxios;